import { getShuffleFacets } from '../../api/shuffle'
import { updateFilterOptions } from '../../components/filters/filterOptions'
import { hasFilterValue } from '../../components/filters/filterValues'
import type { CollectionFiltersState } from './collectionFilters'

const COLLECTION_OVERLAY_FILTER_CONTAINER_ID =
	'collection-overlay-filter-container'

export async function updateCollectionFilterOptions(
	state: CollectionFiltersState,
): Promise<void> {
	try {
		const baseQuery = {
			favoritesOnly: state.favoritesOnly,
			folderId: state.folderId ?? undefined,
			includeHidden: true,
		}
		const baseRequest = getShuffleFacets(baseQuery)
		const [base, styleFacets] = await Promise.all([
			baseRequest,
			hasFilterValue(state.genre)
				? getShuffleFacets({ ...baseQuery, genre: state.genre })
				: baseRequest,
		])
		updateFilterOptions(COLLECTION_OVERLAY_FILTER_CONTAINER_ID, state, {
			genreOptions: base.facets.genres.map(({ value }) => value),
			styleOptions: styleFacets.facets.styles.map(({ value }) => value),
			yearRange: base.facets.yearRange,
		})
	} catch (error) {
		console.error('Failed to load collection filter options', error)
	}
}
